import { ref, watch, computed } from '@vue/composition-api';
import { TABLE, MAS_LIST } from '@/constants/config';
import { pluck } from '@/helpers';

export default function useDirectorInterestsTable() {
    const refComplianceTable = ref(null);

    const perPage = ref(TABLE.PER_PAGE);
    const totalCompliance = ref(0);
    const currentPage = ref(1);
    const perPageOptions = TABLE.PER_PAGE_OPTIONS;
    const searchQuery = ref('');
    const sortBy = ref('id');
    const isSortDirDesc = ref(true);
    const isBusy = ref(false);
    const isLoading = ref(false);
    const tableColumns = ref([]);

    const dynamicTableColumn = currentTab => {
        tableColumns.value = [];

        if(currentTab === 'individual') {
            tableColumns.value = [
                { key: 'selectAll', sortable: false, thClass: 'align-middle py-0 pr-0 pl-1', tdClass:'pl-1 py-0 pr-0'},
                { key: 'firstName', label: 'FIRST NAME', thClass: 'align-middle pl-0 pr-1', tdClass:'pl-0 pr-1'},
                { key: 'secondName', label: 'SECOND NAME', thClass: 'align-middle pl-0 pr-1', tdClass:'py-0 pl-0 pr-1 text-nowrap'},
                { key: 'updatedOn', label: 'UPDATED ON', sortable: false, thClass: 'align-middle pl-0 pr-1', tdClass:'pl-0 pr-1 py-0 text-nowrap'},
                { key: 'scannedOn', label: 'SCANNED ON', sortable: false, thClass: 'align-middle pl-0 pr-1', tdClass:'pl-0 pr-1 py-0  text-nowrap'},
                { key: 'result', label: 'RESULT', sortable: false, thClass: 'align-middle pl-1 pr-1', tdClass:'py-0  pl-1 pr-1'},
                { key: 'actions', label: 'ACTION', thClass: 'align-middle text-right pl-0 pr-1', tdClass:'py-0 pl-0 pr-1' },
            ];
        } else {
            tableColumns.value = [
                { key: 'selectAll', sortable: false, thClass: 'align-middle py-0 pr-0 pl-1', tdClass:'pl-1 py-0 pr-0'},
                { key: 'name', label: 'NAME', thClass: 'align-middle pl-0 pr-0', tdClass:'pl-0 pr-0'},
                { key: 'updatedOn', label: 'UPDATED ON', sortable: false, thClass: 'align-middle pl-0 pr-1', tdClass:'pl-0 pr-1 py-0 text-nowrap'},
                { key: 'scannedOn', label: 'SCANNED ON', sortable: false, thClass: 'align-middle pl-0 pr-0', tdClass:'pl-0 pr-0 py-0  text-nowrap'},
                { key: 'result', label: 'RESULT', sortable: false, thClass: 'align-middle pl-1 pr-1', tdClass:'py-0  pl-1 pr-1'},
                { key: 'actions', label: 'ACTION', thClass: 'align-middle text-right pl-0 pr-1', tdClass:'py-0 pl-0 pr-1' },
            ];
        }
    };
    
    const filterOn = ref([
        'firstName',
        'name',
    ]);

    const dataMeta = computed(() => {
        const localItemsCount = refComplianceTable.value ? refComplianceTable.value.localItems.length : 0;
        totalCompliance.value = localItemsCount;
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalCompliance.value,
        };
    });

    const refetchData = () => {
        refComplianceTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery], () => {
        refetchData();
        const queryLowered = searchQuery.value.toLowerCase().trim();
        
        //  if a query present then search
        if (queryLowered)
        {
            refComplianceTable.value.localItems= refComplianceTable.value.localItems.filter(item => filterOn.value.some(key => {
                const value = pluck(key, item);
                
                return value && value.toString().toLowerCase().trim().includes(queryLowered);
            }));
        }
        isBusy.value = false;
    });

    const resolveMasListStatusVariant = status => {
        if (status === MAS_LIST.STATUS_IMPORTING) return 'primary';
        if (status === MAS_LIST.STATUS_IMPORTED) return 'success';
        if (status === MAS_LIST.STATUS_EXCEPTION_OCCURRED) return 'danger';
        return 'primary';
    };

    return {
        sortBy,
        isBusy,
        perPage,
        dataMeta,
        isLoading,
        searchQuery,
        currentPage,
        isSortDirDesc,
        totalCompliance,
        perPageOptions,
        refComplianceTable,
        resolveMasListStatusVariant,
        dynamicTableColumn,

        refetchData,
        tableColumns,
        filterOn,
    };
}
